import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { subscribersByCategory: { getSubscribersByCategory } } = apiUrls;

export const SUBSCRIBERS_BY_CATEGORY_SUCCESS = 'SUBSCRIBERS_BY_CATEGORY_SUCCESS';
export const SUBSCRIBERS_BY_CATEGORY_LOADING = 'SUBSCRIBERS_BY_CATEGORY_LOADING';

export const getSubscribersByCategoryData = () => async (dispatch) => {
    try {
        const requestData = {
            ...getSubscribersByCategory,
            url: getSubscribersByCategory.url
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: SUBSCRIBERS_BY_CATEGORY_SUCCESS,
            data,
        })
    } catch (e) {
        dispatch({
            type: SUBSCRIBERS_BY_CATEGORY_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }
}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: SUBSCRIBERS_BY_CATEGORY_LOADING,
        isLoading
    })
}